module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', {
    staticClass: "multi-item-title mt-40"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("희망 활동(근무) 조건")]), _vm._v(" "), _c('div', {
    staticClass: "check-util"
  }, [_c('div', {
    staticClass: "check-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefInfoUseYn),
      expression: "prefInfoUseYn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "prefInfo",
      "true-value": "N",
      "false-value": "Y",
      "title": "무관(선호 조건 없음) 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.prefInfoUseYn) ? _vm._i(_vm.prefInfoUseYn, null) > -1 : _vm._q(_vm.prefInfoUseYn, "N")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prefInfoUseYn,
          $$el = $event.target,
          $$c = $$el.checked ? ("N") : ("Y");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.prefInfoUseYn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.prefInfoUseYn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.prefInfoUseYn = $$c
        }
      }
    }
  }), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPreferences
    }
  }, [_c('i', {
    staticClass: "ico ico-refresh"
  }), _vm._v("\n        입력항목 초기화\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap mt-16"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("희망 활동(근무)조건 테이블")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("업직종")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid400"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.desiredOccupationCd),
      expression: "preferences.desiredOccupationCd"
    }],
    attrs: {
      "title": "희망 직종 선택",
      "disabled": _vm.isDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.preferences, "desiredOccupationCd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("희망 직종 선택")]), _vm._v(" "), _vm._l((_vm.codes.desiredOccupationCodes), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v("\n            ※ 현재 설정된 나의 업직종은 "), _c('strong', [_vm._v("'" + _vm._s(_vm.savedOccupationName) + "'")]), _vm._v(" 입니다.\n          ")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("희망시급")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid400"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.desiredSalaryRange),
      expression: "preferences.desiredSalaryRange"
    }],
    attrs: {
      "title": "희망 급여 선택",
      "disabled": _vm.isDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.preferences, "desiredSalaryRange", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("희망 급여 선택")]), _vm._v(" "), _vm._l((_vm.codes.desiredSalaryRanges), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("고용형태")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid400"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.desiredEmploymentTypeCd),
      expression: "preferences.desiredEmploymentTypeCd"
    }],
    attrs: {
      "title": "고용형태 선택",
      "disabled": _vm.isDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.preferences, "desiredEmploymentTypeCd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("고용형태 선택")]), _vm._v(" "), _vm._l((_vm.codes.desiredEmploymentTypeCodes), function(item) {
    return _c('option', {
      key: item.code,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("희망근무지역")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "check-group",
    attrs: {
      "id": "preferences"
    }
  }, _vm._l((_vm.codes.desiredWorkRegions), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "check-wrap"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("region_" + (item.code)),
        "disabled": _vm.isDisabled,
        "title": "선택 선택"
      },
      domProps: {
        "value": item.code,
        "checked": _vm.isChecked(item.code)
      },
      on: {
        "change": function($event) {
          return _vm.handleRegionChange($event, item.code)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("region_" + (item.code))
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mt-16"
  }, [_vm._v("* 현재 설정된 거주지(주소)는 "), _c('strong', [_vm._v("‘" + _vm._s(_vm.district) + "’")]), _vm._v(" 입니다.")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "prefInfo"
    }
  }, [_c('span', [_vm._v("무관(선호 조건 없음)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166823a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/Preferences.vue
// module id = 1305
// module chunks = 6